import { useMutation, UseMutationResult } from 'react-query';
import type { MutationError } from '../../type';
import { loginService, registerService } from './service';
import type { IAuth, ILoginData, IRegister, IUserData } from './type';
import { useStore } from '../../../store/useStore';

export const useLogin = (): UseMutationResult<
  ILoginData,
  MutationError,
  IAuth
> => {
  const { setAuthState } = useStore();

  return useMutation({
    mutationFn: (loginData: IAuth) => {
      return loginService(loginData);
    },
    onSuccess: (data) => {
      localStorage.setItem('sessionId', data?.SessionId);
      localStorage.setItem('userId', String(data?.user_info?.UserID));
      // Update store state
      setAuthState(data?.SessionId, String(data?.user_info?.UserID));
    },
  });
};

export const useRegister = (): UseMutationResult<
  IUserData,
  MutationError,
  IRegister
> => {
  const { setAuthState } = useStore();

  return useMutation({
    mutationFn: (registerData: IRegister) => {
      return registerService(registerData);
    },
    onSuccess: (data) => {
      localStorage.setItem('sessionId', data?.SessionId);
      // localStorage.setItem('userId', String(data?.user_info?.UserID));
      // Update store state
      setAuthState(data?.SessionId, null);
    },
  });
};
